export const timeFormat = (time) => {
    let hour = time.split(':')[0];
    let minute = time.split(':')[1];

    if (hour >= 12) {
        if (hour == 12) {
            let h = hour
            let m = minute + ' pm'
            return h + ":" + m
        } else {
            let h = hour - 12
            let m = minute + ' pm'
            return h + ":" + m
        }

    } else {
        let h = parseInt(hour)
        return h + ':' + minute + ' am'
    }
}